// @ts-nocheck

import { Locales } from '../../../../../types/common';

import BannerDE from './gr_banner_DE.jpg';
import BannerEN from './gr_banner_EN.jpg';
import BannerES from './gr_banner_ES.jpg';
import BannerFR from './gr_banner_FR.jpg';

export const GRBannerFR = BannerFR;
export const GRBannerEN = BannerEN;
export const GRBannerDE = BannerDE;
export const GRBannerES = BannerES;

export const GRBannerImgByLang = {
  [Locales.FR]: GRBannerFR,
  [Locales.EN]: GRBannerEN,
  [Locales.DE]: GRBannerDE,
  [Locales.ES]: GRBannerES,
};
